import { capexService } from '@modules/capex/infrastructure/capex.service'

type Callbacks = {
  onSuccess: () => void
  onNetworkError: (error: unknown) => void
}

export function handleUploadCapexFile() {
  return { execute }

  async function execute(file: File, { onSuccess, onNetworkError }: Callbacks) {
    try {
      await capexService.uploadCapexFile(file)
      onSuccess()
    } catch (error) {
      onNetworkError(error)
    }
  }
}
